var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "34px",
    viewBox: "0 0 26 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doc.") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0001 0.0002 26 0.0002 26 34 0.0001 34"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document_voorb.3",
    transform: "translate(-30.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#F8F8F8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 762,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "doc.",
    transform: "translate(30.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0001,31 L3.0001,31 L3.0001,12 L9.2761,12 C10.7781,12 12.0001,10.778 12.0001,9.276 L12.0001,3 L23.0001,3 L23.0001,31 Z M5.1211,9.122 L10.0001,4.243 L10.0001,9.276 C10.0001,9.675 9.6751,10 9.2761,10 L4.2431,10 L5.1211,9.122 Z M24.2761,0 L12.0001,0 L10.0001,0 L3.0001,7 L0.0001,10 L0.0001,32.276 C0.0001,33.229 0.7711,34 1.7241,34 L24.2761,34 C25.2281,34 26.0001,33.229 26.0001,32.276 L26.0001,1.724 C26.0001,0.772 25.2281,0 24.2761,0 L24.2761,0 Z",
    id: "Fill-1",
    fill: "#332E20",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.50de175599a99bbb6aacc22d64985c22.svg";
export { ForwardRef as ReactComponent };